import React, { useEffect } from "react";
import image from "../resources/fullFace.png";
import "./about.css";
import "./pages.css";
import { Document, Page, pdfjs } from 'react-pdf';
import ProgressBar from "react-bootstrap/ProgressBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
// import resumePng from "../resources/resume.png";

import AOS from "aos";
import "aos/dist/aos.css";

const AboutMe = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out" });
  }, []);

  const codingSkills = [
    { label: "C++", value: 85 },
    { label: "React", value: 90 },
    { label: "JavaScript", value: 85 },
    { label: "Java", value: 85 },
    { label: "Python", value: 60 },
    { label: "HTML/CSS", value: 90 }
  ];

  const artSkills = [
    { label: "Digital Art", value: 95 },
    { label: "Adobe Suite", value: 85 },
    { label: "Watercolor", value: 80 },
    { label: "Pencil", value: 50 },
    { label: "Acrylic", value: 70 },
  ];

  const awards = [
    "1st Place – 2023 Congressional App Challenge (IL-08)",
    "2023 Rise for the World Global Finalist",
    "2023 UN Honor – Volunteer Impact Award",
    "BPA Graphic Design – 2nd (State), 4th (Nationals)",
    "BPA Graphic Design – 1st (State), 3rd (Nationals)",
    "NCWIT AiC 2022 National Honorable Mention & State Winner",
    "NCWIT AiC 2021 State Honorable Mention",
    "AP Scholar with Distinction (2022, 2023)",
    "Microsoft Imagine Cup 2022 Semi-Finalist",
    "2nd Place – 2021 Congressional App Challenge",
    "2nd Place – 2021 Congressional Art Competition",
    "District 54 Boardroom Artist (2020, 2018)",
  ];

  return (
    <div>
      <section className="allInfo">
        {/* About Card */}
        <div className="card">
          <div className="details" data-aos="fade-left">
            <div className="content">
              <h2 className="mainTitle">about.</h2>
              <h4>
                <span>artist & coder based in Chicago, IL</span>
                <br /><br />
                Hi, I’m <strong>Siya Choudhary</strong>, a computer science student at the University of Illinois Urbana-Champaign. I’m also an artist and illustrator passionate about weaving creativity into everything I build.
                {/* <br /><br />
                Whether it’s designing clean interfaces or illustrating vibrant digital worlds, I love creating things that leave a lasting impact. I’m always exploring the intersection of logic and imagination—and finding ways to make that blend useful, inclusive, and beautiful. */}
              </h4>
            </div>
          </div>
          <div className="imgBx" data-aos="fade-right">
            <img src={image} alt="Siya Choudhary" />
          </div>
        </div>

        

        {/* Skills Card */}
        <div className="skills card">
          <h1 className="awardsTitle mainTitle">skills.</h1>

          <div className="skills-grid">
            <div className="skills-column">
              <h4>Programming Languages</h4>
              <ul className="skill-list">
                {codingSkills.map((skill) => (
                  <li key={skill.label} className="skill-row" data-aos="fade-right">
                    <span className="skill-label">{skill.label}</span>
                    <ProgressBar
                      now={skill.value}
                      className="progress"
                      variant="info"
                    />
                  </li>
                ))}
              </ul>
            </div>
            <div className="skills-column">
              <h4>Art & Design</h4>
              <ul className="skill-list">
                {artSkills.map((skill) => (
                  <li key={skill.label} className="skill-row" data-aos="fade-right">
                    <span className="skill-label">{skill.label}</span>
                    <ProgressBar
                      now={skill.value}
                      className="progress"
                      variant="info"
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Awards Card */}
        <div className="awards card">
          <h1 className="awardsTitle mainTitle">awards.</h1>
          <ul>
            {awards.map((award, index) => (
              <li key={index} className="awardTxt" data-aos="fade-right">
                <FontAwesomeIcon icon={faTrophy} className="trophy" /> {award}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default AboutMe;
